module.exports = __webpack_public_path__ + "img/F5-1B.12128b03.png";